import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError, serializeForm} from "../../fn";

/**
 * Получить данные по субъекту
 * @param id
 * @returns {Promise<HttpResponseOk|HttpResponseError>}
 */
export const getSubject = async (id) => {
  return await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/subject/${id}`, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data));
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Добавить нового субъекта
 * @param subjectId
 * @param values
 * @returns {Promise<HttpResponseOk|HttpResponseError>}
 */
export const createSubject = async (values) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/subject/`, values, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(function (response) {
        resolve(httpResponse(response.data));
      })
      .catch(function (error) {
        resolve(httpResponseError(error));
      });
  })

  return result;
}

/**
 * Обновить данные субъекта
 * @param values
 * @returns {Promise<HttpResponseOk|HttpResponseError>}
 */
export const updateSubject = async (values) => {
  return await new Promise((resolve) => {
    axios.put(`${getBackendURL()}/subject/`, values, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(function (response) {
        resolve(httpResponse(response.data));
      })
      .catch(function (error) {
        resolve(httpResponseError(error));
      });
  });
}